<template>
  <div class="page lieviti-liquidi">
    <ListingList
      :indexes="indexes"
      :defaultFacetsFilters="defaultFacetsFilters"
      :filter="filter"
      :currentCustomContent="currentCategory"
      :pageHandle="birraPage.typeHandle"
      :categories="categories"
      :subcategories="subcategories"
      :introSection="currentCategory.sezioneIntroProdotti[0]"
      :parentIntroSectionImage="birraPage.sezioneIntroProdotti[0].portrait"
      :hideSidebar="true"
      :hideListing="true"
    >
      <template v-slot>
        <GeneralHeader
          v-for="(header, index) in currentCategory.generalHeader"
          :key="index"
          :header="header"
          customStyle="no-top no-row"
        />
        <TextImageWithBg
          v-for="(block, index) in currentCategory.sezioneImmagineTesto"
          :key="index"
          :block="block"
          type="custom3"
          customStyle="no-row"
        />
        <TitleText
          v-for="(item, index) in currentCategory.sezioneTitoloTestoPagina"
          :key="index"
          :item="item"
          customStyle="no-row"
        />
      </template>
    </ListingList>
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'
import { parseQueryFacets } from '~/assets/js/utils/algolia.js'
import {
  useBirraData,
  generateBirraDefaultFacetsFilters,
} from '~/composables/birra-data.js'
import { useHelpers } from '~/composables/helpers.js'

const route = useRoute()
const indexes = ['section_birra']
const filter = route.query?.filter ? parseQueryFacets(route.query?.filter) : []

const { configuration } = useStore()

const query = queries.birraPage.getBirraPage
const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)
if (!data.value.birraPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const { categories, subcategories } = useBirraData(data)

const currentCategory = computed(() => {
  return (
    data.value.categories.find(
      (category) => category.key === 'lieviti-liquidi',
    ) || {}
  )
})

const isValidCategory = computed(() => {
  return currentCategory.value.key === 'lieviti-liquidi'
})

if (!isValidCategory.value) {
  throw createError({ statusCode: 404 })
}

const defaultFacetsFilters = computed(() => {
  const defaultFacets = generateBirraDefaultFacetsFilters(currentCategory)

  return [...defaultFacets]
})

const seo = computed(() => currentCategory.value.seo || {})

const localeParams = computed(() => currentCategory.value.localized || [])

useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})

const birraPage = computed(() => data.value.birraPageEntries?.[0])
</script>
